import { useEffect, useState } from 'react'

const WAIT_TIME_FOR_RE_REQUEST_MESSAGE = 30_000

export const useShowOneTimePasswordReRequestMessage = (): boolean => {
  const [showReRequestMessage, setShowReRequestMessage] = useState(false)

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setShowReRequestMessage(true)
    }, WAIT_TIME_FOR_RE_REQUEST_MESSAGE)

    return (): void => {
      window.clearTimeout(timeout)
    }
  }, [])

  return showReRequestMessage
}
